import { useQuery } from "@tanstack/react-query";

import { getPublishedArticles, getArticleBySlug } from "../api/articlesApi";

/**
 * Article queries, following `useSystemQueries.js`'s conventions: a keys
 * object so nothing invents a query key inline, and a `staleTime` chosen for
 * how fast the underlying data actually changes.
 */
export const articleQueryKeys = {
  all: ["articles"],
  list: () => [...articleQueryKeys.all, "list"],
  detail: (slug) => [...articleQueryKeys.all, "detail", slug],
};

/**
 * Ten minutes. Articles change when someone publishes one, which is rare and
 * already triggers a full rebuild — so the aggressive end of the range is
 * right here, unlike the five minutes used for water-system data that a
 * visitor might reasonably expect to be fresher.
 */
const STALE_TIME = 10 * 60 * 1000;

export const useArticles = (options = {}) =>
  useQuery({
    queryKey: articleQueryKeys.list(),
    queryFn: getPublishedArticles,
    staleTime: STALE_TIME,
    ...options,
  });

export const useArticle = (slug, options = {}) =>
  useQuery({
    queryKey: articleQueryKeys.detail(slug),
    queryFn: () => getArticleBySlug(slug),
    enabled: Boolean(slug),
    staleTime: STALE_TIME,
    ...options,
  });
